module.exports = {"toolbar":{"commons":{"lock":"Unlock toolbar","unlock":"Lock toolbar","automation":"Automation settings"},"ungroup":{"button":"Ungroup"},"group":{"button":"Group"},"keyframe":{"button":"Keyframe"},"image-object":{"button":"Edit"},"mask":{"button":"Mask"},"unmask":{"button":"UnMask"}}}


//////////////////
// WEBPACK FOOTER
// ./src/translations/en/toolbar.json
// module id = 798
// module chunks = 32